snap<template>
    <div
        class="cz2__steps-options__name"
        :class="[
            `cz2__steps-options__name--sb-type-${spellingBeeType}`,
            {
                'is-kiosk': isKiosk,
                'is-virtualkeyboard': useVirtualKeyboardNameEntry,
            },
        ]"
    >
        <div
            v-if="isMobile"
            class="cz2__name--header"
        >
            <funko-logos />

            <main-navigation class="cz2__main-navigation-wrapper" />

            <share-buttons
                v-if="!isSpellingBee && isMobile && !isKiosk && showShareButtons"
                class="cz2__review-share-buttons"
            />
        </div>

        <mariners-header v-else />

        <div
            ref="rendererPlaceholder"
            class="cz2__renderer-placeholder"
        />

        <div class="cz2__renderer-placeholder-spacer" />

        <pop-view-toggle
            v-if="!isKiosk"
            class="cz2__review-toggle-buttons"
        />

        <div class="cz2__steps-options__name-label-wrapper">
            <label
                for="name-input"
                class="cz2__steps-options__name-label"
            >
                {{ $t('NAME') }}
            </label>
            <base-input
                id="name-input"
                name="name-input"
                ref="nameInput"
                :input-text="name"
                :invalid="invalid"
                :error-text="errorText"
                :small-font="smallFont"
                :read-only="useVirtualKeyboardNameEntry || isKiosk"
                :outlined="isKiosk"
                :maximum-length="maxLength"
                :inputPlaceholder="$t('NAME_PLACEHOLDER')"
                labelled-by="step-header-title"
                @input="updateName"
                class="cz2__steps-options__name-input"
            />
        </div>

        <div
            v-if="isKiosk || useVirtualKeyboardNameEntry"
            class="cz2__steps-options__name-keyboard"
        >
            <keyboard
                :value="name"
                @input="updateNameKeyboard"
                @quotes="quotes"
                :layouts="[
                    '1234567890{DELETE:backspace}|QWERTYUIOP_|ASDFGHJKL-+|{@#Ñ:goto:1}ZXCVBNM,.@|{:space}',
                    `!@#$%^&*(){DELETE:backspace}|ÁÉÍÓÚÜÑ¡/\\_|:;||<=>[]~-+|{ABC:goto:0}{{}}'\`{″:quotes}¿?,.@|{:space}`,
                ]"
            />
        </div>

        <share-buttons
            v-if="!isSpellingBee && !isMobile && !isKiosk && showShareButtons"
            class="cz2__review-share-buttons"
        />
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__sb-logo__name-m, .cz2__sb-logo__name-d, .cz2__sb-logo__name-k {
            display: none;
        }

        .cz2__steps-options__name {
            pointer-events: auto;

            padding: 24px 32px calc(var(--steps-options-nav-height) + 32px) 32px;
            padding-bottom: calc(var(--steps-options-nav-height) + var(--layout-spacing));

            height: 100%;
            @include bg(gradientBlue);

            display: flex;
            flex-direction: column;
            align-items: center;

            .cz2__renderer-placeholder {
                width: 100%;
                flex: 1 1 0%;
            }
        }

        .cz2__name--header {
            width: 100%;
            display: grid;
            grid-template-columns: 0.5fr 3fr 0.5fr;
            align-items: flex-start;

            .cz2__funko-logos {
                margin: 0;
                padding: 0;
                justify-self: flex-start;
            }

            .cz2__main-navigation-wrapper {
                justify-self: center;
                align-self: center;

                .cz2__main-navigation-button-content-wrapper {
                    &::before {
                        left: -1px;
                        width: 105%;
                    }
                }

                .cz2__main-navigation-button-content {
                    font-size: 20px;
                }
            }

            .cz2__review-share-buttons {
                align-self: center;
                margin-left: 8px;
            }
        }

        .cz2__renderer-placeholder-spacer {
            height: 32px;
        }

        .cz2__review-toggle-buttons {
            margin-top: 24px;
        }

        .cz2__steps-options__name-label-wrapper {
            width: 100%;
            padding: 0 32px;
        }

        .cz2__steps-options__name-input {
            margin-bottom: 56px;

            width: 100%;
            display: flex;
            justify-content: center;

            .cz2__input-box {
                width: 100%;
            }
        }

        @include respond-above(sm) {
            .cz2__steps-options__name-label-wrapper,
            .cz2__input-box {
                width: 550px;
            }
        }

        @include respond-above(md) {
            .cz2__name--header {
                grid-template-columns: 1fr 2fr 1fr;

                .cz2__main-navigation-wrapper {
                    .cz2__main-navigation-button-content {
                        font-size: inherit;
                    }
                }
            }

            .cz2__review-share-buttons,
            .cz2__review-toggle-buttons {
                z-index: 1;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }

            .cz2__review-share-buttons {
                margin-left: 0;
                left: 32px;
            }

            .cz2__review-toggle-buttons {
                margin-top: 0;
                right: 32px;
            }
        }

        @include respond-above(lg) {
            .cz2__steps-options__name,
            .cz2__funko-logo--is-name {
                padding: 32px var(--layout-spacing) var(--steps-options-nav-height) var(--layout-spacing);
            }

            .cz2__steps-options__name-label-wrapper,
            .cz2__input-box {
                width: 500px;
            }

            .cz2__steps-options__name-label-wrapper {
                margin-top: 32px;
                padding: 0;
            }
        }

        @include respond-above(xl) {
            .cz2__funko-logo--is-name {
                flex-direction: row;
                gap: 24px !important;

                .sm-x-icon {
                    height: 42px;
                    transform: none;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__steps-options__name {
            gap: 40px;

            .cz2__name--header {
                grid-template-columns: auto;
            }

            .cz2__funko-logo-link {
                display: none;
            }

            .cz2__main-navigation-button {
                margin-top: 110px;
                margin-left: -50px;
            }

            .cz2__main-navigation-button-enlarge-text {
                font-size: 90px;
            }

            .cz2__steps-options__name-input {
                margin-bottom: 20px;

                .cz2__input-box {
                    width: 600px;
                }

                // Make room for longer error message.
                .cz2__input-box__error {
                    width: 100vw;
                    left: 50%;
                    transform: translateX(-50%);
                    text-align: center;
                    font-size: 24px;
                }
            }
        }
    }

    .cz2__steps-options__name-label {
        display: block;
        margin-bottom: 8px;
        font-family: 'Proxima Nova';
        font-size: 18px;
        font-weight: 600;
        color: #fff;
    }

    #cz2.cz2.cz2__is-sb.cz2__is-name-step {

        .cz2__steps-options__name {
            padding: 50px 50px 80px;

            @include respond-above(sm) {
                padding: 90px 0 130px;
            }

            background-size: 50%;
            background-position: center;
            background-repeat: repeat;

            &.cz2__steps-options__name--sb-type-none {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-G {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-H {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-S {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-R {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                }
            }

            background-size: cover;

            background-image: none;
            background-color: transparent;

            position: absolute;
            border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_M@2x.webp');

            border-width: 40px;
            border-image-width: 40px;
            border-image-slice: 80 fill;
            border-image-repeat: stretch;

            height: calc(100% - var(--steps-options-nav-height-sb));
            width: 100%;

            @include respond-above(lg) {
                border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_D@2x.webp');
                height: 100%;
                width: 100%;
                border-width: 70px;
                border-image-width: 70px;
                border-image-slice: 140 fill;
                border-image-repeat: stretch;
            }
        }

        .cz2__steps-options__navigation--name {
            @include respond-above(lg) {
                bottom: 50px;
            }
        }
        .cz2__input-box {
            @include respond-above(lg) {
                margin-bottom: 64px;
                padding-bottom: 0;
            }
            input {
                border-radius: 0;
                border-color: color(sbDarkGold);
                border-width: 4px;
            }
            &.cz2__input-box--active {
                box-shadow: none;
            }
        }
        .cz2__steps-options__name-input {
            margin-bottom: 0;
        }
        .cz2__sb-logo__name-m {
            display: block;
            height: 80px;
        }
        @include respond-above(lg) {
            .cz2__sb-logo__name-m {
                display: none;
            }
            .cz2__sb-logo__name-d {
                display: block;
                height: 120px;
            }
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-name-step.cz2__is-kiosk {
        .cz2__steps-options__name {
            height: calc(100% - var(--steps-options-nav-height-sb));

            padding: 90px 0 130px;
        }

        .cz2__main-navigation-button {
            margin-top: 24px;
        }

        .cz2__input-box {
            margin-bottom: 24px;
        }

        .cz2__steps-options__navigation--name {
            bottom: 0;
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__steps-options__name {
            @include bg(gradientSM);

            padding-left: 0;
            padding-right: 0;

            .cz2__steps-options__name-input{
                padding: 0;
            }

            .cz2__mariners--header {
                padding: 0 16px;
            }

            @include respond-above(lg) {
                .cz2__mariners--header {
                    padding: 0 32px;
                }

                .cz2__funko-logo-wrapper {
                    gap: 50px;
                }

                .cz2__funko-logo,
                .cz2__funko-logo-link {
                    height: 38px !important;
                    width: auto;
                }

                .cz2__mariners-pop-logo {
                    height: 88px !important;
                }
            }

            @include respond-above(xl) {
                .cz2__mariners--header {
                    padding: 0 56px;
                }
            }
        }
    }
</style>

<script>
    import * as constants from '../constants';

    import Keyboard from './ui/Keyboard.vue';

    import MainNavigation from './MainNavigation.vue';
    import BaseInput from './ui/BaseInput.vue';
    import FunkoLogos from './FunkoLogos.vue';
    import ShareButtons from './ShareButtons.vue';
    import PopViewToggle from './PopViewToggle.vue';
    import MarinersHeader from './MarinersHeader.vue';

    export default {
        components: {
            MainNavigation,
            Keyboard,
            BaseInput,
            FunkoLogos,
            ShareButtons,
            PopViewToggle,
            MarinersHeader,
        },

        props: {
            validate: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                invalid: null,
                errorText: '',
                name: '',
                maxLength: 18,
            };
        },

        computed: {
            popControllers() {
                return this.$store.getters.popControllers;
            },

            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            spellingBeeType() {
                return this.$store.state.spellingBeeType ?? 'none';
            },

            boxName() {
                return this.viewController.selectedAtPlacement(constants.PLACEMENT_BOX_NAME)?.custom['personalization-text'];
            },

            options() {
                return this.$store.state.customizer.options;
            },

            isKiosk() {
                return this.options && this.options.isKiosk;
            },

            useVirtualKeyboardNameEntry() {
                if (this.options && this.options.useVirtualKeyboardNameEntry) {
                    return true;
                }

                return false;
            },

            smallFont() {
                return (this.name || '').length > 8;
            },

            seenGroups() {
                return this.$store.state.customizer.seenGroups;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            noSavePreviews() {
                return this.$store.state.customizer.noSavePreviews;
            },

            isFirstPop() {
                return this.$store.state.customizer.viewController === this.$store.getters.popControllers[0];
            },

            pop2Started() {
                return Object.keys(this.$store.state.customizer.seenGroupsByController).length > 1;
            },

            showShareButtons() {
                return !this.isTwoPack || (this.isTwoPack && !this.isFirstPop && this.pop2Started);
            },

            isMariners() {
                return this.$store.state.isMariners;
            },
        },

        watch: {
            validate() {
                this.validateName();
            },

            currentGroup() {
                this.updateNavigation();
            },
        },

        beforeMount() {
            // Prefer box view.
            this.$store.dispatch('setSelectedToggleView', this.isTwoPack ? 'Main Mini' : 'BoxName');
        },

        mounted() {
            const name = this.boxName;
            let useName = '';

            if (name) {
                if (name.controller) {
                    useName = name.text;
                } else {
                    useName = name;
                }
            }

            this.name = useName;

            this.updateNavigation();

            this.setFocusOnInput();

            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'name',
                placeholder: this.$refs.rendererPlaceholder,
            });

            this.emitter.$emit('isCameraLoading', (isLoading) => {
                if (!isLoading) {
                    this.getPreviews().then(() => {
                        this.takeAbandonedRecipe().then(() => {
                        });
                    });
                }
            });

            this.emitter.$on('cameraLoading', this.cameraLoading);
        },

        beforeDestroy() {
            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'name',
            });

            this.emitter.$off('cameraLoading', this.cameraLoading);
        },

        methods: {
            quotes() {
                this.updateNameKeyboard(`${this.name}"`);
            },

            updateNavigation() {
                let returnTo;
                let nextSpecialStep = 'Checkout';

                if (this.seenGroups.includes('Packs')) {
                    returnTo = 'Packs';
                } else if (this.seenGroups.includes('Pets')) {
                    returnTo = 'Pets';
                } else if (this.seenGroups.includes('Accessories3')) {
                    returnTo = 'Accessories3';
                } else if (this.seenGroups.includes('Accessories2')) {
                    returnTo = 'Accessories2';
                } else if (this.seenGroups.includes('Accessories1')) {
                    returnTo = 'Accessories1';
                }

                if (this.isKiosk) {
                    nextSpecialStep = 'Contact';
                }

                this.$emit('updateNavigation', {
                    hasBack: true,
                    canGoBack: true,
                    hasNext: true,
                    canGoNext: this.name.length > 0,
                    nextSpecial: nextSpecialStep,
                    previousSpecial: returnTo,
                    isValidating: false,
                    invalid: this.invalid,
                });
            },

            updateNameKeyboard(newValue) {
                // updateName will trim the name and remove trailing spaces.
                // You can still enter names with spaces because <input> tracks the internal state.
                //
                // But we need to allow the screen keyboard to enter trailing spaces too.
                // If we use updateName, the user can never enter a space.
                //
                // So, instead, if a newly entered name only differs by trailing spaces,
                // simply update the state but skip validations.
                //
                // Only if the new name ends with a space. The screen keyboard does not have a way to move the cursor.
                if (newValue && newValue.substr(newValue.length - 1) === ' ') {
                    const newWithoutSpaces = newValue.replace(/\s+$/, '');

                    if (newWithoutSpaces === this.name) {
                        this.name = newValue;
                    } else {
                        this.updateName(newValue);
                    }
                } else {
                    this.updateName(newValue);
                }
            },

            updateName(newValue) {
                this.name = newValue.trim();

                this.$store.dispatch('updateBoxName', this.name).then((useName) => {
                    this.name = useName;

                    if (newValue.length > this.maxLength) {
                        this.$nextTick(() => {
                            this.invalid = true;
                            this.errorText = this.$t('BOX_NAME_ERROR');
                        });
                    } else {
                        this.invalid = false;
                        this.errorText = '';

                        // Enable/disable Next button as user types
                        this.$emit('updateNavigation', {
                            canGoNext: this.name.length > 0,
                            isValidating: false,
                            invalid: true,
                        });
                    }
                });
            },

            validateName() {
                this.viewController.reviewText(this.name).then((result) => {
                    if (result.hasProfanity) {
                        this.invalid = true;
                        this.errorText = this.$t('BOX_NAME_ERROR_PROFANITY');

                        // Clear profanity from screen on kiosk
                        if (this.isKiosk) {
                            this.name = '';
                            this.$store.dispatch('updateBoxName', '');
                        }
                    } else {
                        this.invalid = false;
                    }

                    this.updateNavigation();
                }).catch(() => {
                    this.invalid = true;
                    this.errorText = this.$t('BOX_NAME_ERROR_PROFANITY');

                    this.updateNavigation();
                });
            },

            setFocusOnInput() {
                if (!this.isMobile) {
                    const inputElement = this.$refs.nameInput.$el.children[0].querySelector('input');

                    inputElement.focus();
                }
            },

            saveRecipe() {
                return this.$store.dispatch('customizerDone', {
                    type: 'cart',
                    noBusy: true,
                    noVariants: true,
                    saveTemporary: true,
                }).then((recipeData) => {
                    this.$store.dispatch('setSavedRecipe', recipeData);
                });
            },

            async getPreviews() {
                if (this.noSavePreviews) {
                    return;
                }

                if (this.previewDebounce) {
                    clearTimeout(this.previewDebounce);
                }

                // eslint-disable-next-line
                console.log('[NAME] Save previews...');

                this.previewDebounce = setTimeout(async () => {
                    // eslint-disable-next-line
                    console.log('[NAME] Save previews debounced...');

                    // A single pop should be already good to go, but we don't want to resnap two pack pops all the time.
                    if (this.isTwoPack) {
                        if (!this.tookOneSnapshot) {
                            this.tookOneSnapshot = true;

                            const popSnapshot = await this.$store.dispatch('snapshot', {
                                view: 'SnapshotNarrow',
                                onlyController: this.viewController,
                            });

                            this.$store.dispatch('setPreviewImageByController', popSnapshot);
                        }

                        if (!this.tookSnapshots) {
                            this.tookSnapshots = true;

                            // eslint-disable-next-line
                            for (const pop of this.popControllers) {
                                // Snap each pop too.
                                // eslint-disable-next-line no-await-in-loop
                                const thisPopImage = await this.$store.dispatch('snapshot', {
                                    view: 'SnapshotPop',
                                    onlyController: pop,
                                });

                                this.$store.dispatch('setCartImageBySpecificController', {
                                    controller: pop,
                                    image: thisPopImage,
                                });
                            }
                        }
                    }
                }, 300);
            },

            takeAbandonedRecipe() {
                return new Promise((resolve) => {
                    if (this.cartDebounce) {
                        clearTimeout(this.cartDebounce);
                    }

                    // eslint-disable-next-line
                    console.log('[NAME] Create abandoned cart recipe');

                    this.cartDebounce = setTimeout(() => {
                        let needSave = false;

                        if (!this.gotAbandonedRecipe) {
                            this.gotAbandonedRecipe = true;
                            if (!this.isTwoPack || this.pop2Started) {
                                needSave = true;
                                this.saveRecipe().then(() => {
                                    // eslint-disable-next-line
                                    console.log('[NAME] ... Done');
                                    resolve();
                                });
                            }
                        }

                        if (!needSave) {
                            // eslint-disable-next-line
                            console.log('[NAME] Not needed');

                            resolve();
                        }
                    }, 300);
                });
            },

            cameraLoading(loading) {
                if (!loading) {
                    // If camera finished loading while we were on this step, recapture the screenshots.
                    this.getPreviews().then(() => {
                        this.takeAbandonedRecipe().then(() => {
                        });
                    });
                }
            },
        },
    };
</script>
